import { Link } from "react-router-dom";
import { SectionEyebrow, SectionTitle, FadeUp } from "./_shared";
import { TechnologyExplorer } from "./_partials/TechnologyExplorer";

export default function TechCards() {
  return (
    <section id="technology" data-testid="tech-cards-section" className="py-24 md:py-32 bg-card/40 border-y border-border">
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <FadeUp className="text-center max-w-3xl mx-auto">
          <SectionEyebrow>Patent-Pending IP</SectionEyebrow>
          <SectionTitle className="mt-4 text-[clamp(1.9rem,4.5vw,3.25rem)]">
            The Technology Behind <em className="not-italic text-primary">Integrated Clinical Intelligence</em>
          </SectionTitle>
        </FadeUp>

        <FadeUp className="mt-14">
          <TechnologyExplorer />
        </FadeUp>

        <FadeUp delay={0.2} className="mt-10 text-center">
          <Link to="/technology" data-testid="tech-explore-platform-link" className="iw-btn-ghost inline-flex items-center gap-2 px-7 py-3.5 text-xs">
            Explore the Full Technology Platform <span aria-hidden>→</span>
          </Link>
        </FadeUp>
      </div>
    </section>
  );
}